import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router";
import { Box, Container } from "@mui/material";

import { getBreadcrumbIndustryRoute } from "@/utils/getBreadcrumbRoute";
import { getCurrentIndustryCard } from "@/utils/industries/getCurrentIndustryCard";
import {
  INDUSTRIES,
  industriesTypes,
  industriesRoutes,
  ROUTES,
} from "@/utils/navigation";

import Breadcrumb from "@/components/UI-Kit/Breadcrumb";
import CustomTabs from "@/components/CustomTabs";
import IndustryCard from "@/components/Industries";
import Section from "@/components/Section";

const Industries = () => {
  const { type } = useParams();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState<number>(0); // Active industry tab state
  const [currentCard, setCurrentCard] = useState<IIndustryCard | null>(null);
  const breadcrumbOptions = getBreadcrumbIndustryRoute(activeTab); // Get breadcrumbs
  const options = industriesRoutes.map(({ Icon }) => ({ icon: <Icon /> })); // Get tabs options

  // Set active industry tab and navigate to chosen page
  const handleChange = (newValue: number) => {
    setActiveTab(newValue);
    setCurrentCard(null);
    navigate(industriesRoutes[newValue].path);
  };

  // Check if industry type is valid and redirect to the chosen industry page
  // Otherwise navigate to Not Found page
  useEffect(() => {
    if (!type) {
      navigate(`${ROUTES.industries}/${INDUSTRIES.carShare}`);
    } else {
      // Check if the type is valid
      const isValidType = industriesTypes.includes(type);

      // Redirect to NotFound if type is not valid
      // Otherwise set active tab and navigate to chosen industry page
      if (!isValidType) {
        navigate(`${ROUTES.industries}/${INDUSTRIES.carShare}`);
      } else {
        const activeRouteIdx = industriesRoutes.findIndex((route) =>
          route.path.endsWith(type)
        );
        setActiveTab(activeRouteIdx);
        const card = getCurrentIndustryCard(type);
        setCurrentCard(card);
      }
    }
  }, [navigate, type]);

  return (
    <>
      <Container sx={{ pt: { xs: 3, lg: 0 }, pb: { xs: 3, lg: 4.5 } }}>
        <Breadcrumb options={breadcrumbOptions} />
      </Container>
      <Section
        pt={0}
        pb={{ xs: 10, lg: 30 }}
        sectionSx={{ minHeight: !currentCard ? "100vh" : "auto" }}
      >
        <Box mb={{ xs: 4, md: 10, lg: 15.75 }}>
          <CustomTabs
            value={activeTab}
            onChange={handleChange}
            options={options}
            type="icon"
          />
        </Box>
        {currentCard && <IndustryCard industryCard={currentCard} />}
      </Section>
    </>
  );
};

export default Industries;
